import { Box, SearchField } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { useMessageFilterContext } from 'modules/bookkeepers/lib/MessageFilterContext'

import IncidencesFilters from './_IncidencesFilters'

interface Props {
  messageTab: boolean
  collapsibleSearchBar: boolean
}

const FiltersBar = ({ messageTab, collapsibleSearchBar }: Props) => {
  const incidenceFilters = useIncidenceFilterContext()
  const messageFilters = useMessageFilterContext()
  const { search, onSearch } = messageTab ? messageFilters : incidenceFilters

  return (
    <Box
      width="full"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      gap="s8"
    >
      <Box flexDirection="row" gap="s8" flexGrow alignItems="center" width="full">
        <Box width="full" paddingY="s12">
          <Box
            gap="s24"
            flexNoShrink
            flexDirection="row"
            alignItems="flexEnd"
            justifyContent="spaceBetween"
            border={{ right: { width: 's2', color: 'grey200', style: 'solid' } }}
          >
            <Box>
              <IncidencesFilters messageTab={messageTab} />
            </Box>
            <Box flexDirection="row" paddingRight="s8">
              <SearchField
                placeholder={i18n.t('common.search')}
                search={search}
                onSearch={onSearch}
                collapsable={collapsibleSearchBar}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(FiltersBar)
